import {IMAGE_DEFAULT_FORMATS} from "../../../../core/app/consts";
import {AssetsRequestParams} from "../../../../infrastructure/models/params/assets-request-params";
import {useThemeColor} from "../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../../core/app/consts/colors";

export class TopTrendFlameImageRequestParams extends AssetsRequestParams {
  constructor() {
    super();
    this.resourceName = `${this.resourceName}/flame`;
    this.color = useThemeColor(COLORS.dangerPrimary)
    this.ratio = 1;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.PNG;
  }
}
